export default __webpack_public_path__ + "d885672bafc92114557447ad1f6eb35b.gif";